export default (defaults = {}) => ({
  getLabel: status => `E-Mail-Template für den Status "${status}"`,
  subject: {
    plural: 'E-Mail-Templates',
    singular: 'E-Mail-Template'
  }
})
